<template>
  <div>
    <BackgroundClouds v-if="BackgroundClouds" />
    <NvarWeb v-if="nvar" @update-estadoPadre="actualizarVariables" />
    <NvarDash v-if="nvarDash" @update-estadoDash="actualizarVariablesDash" />
    <router-view :is-active="isActive" :is-active2="isActive2" :is-active3="isActive3"
      @update-estadoLogin="actualizarVariables" />
    <FooterWeb v-if="nvar" />
  </div>
</template>

<script>
import { watch } from "vue";
import BackgroundClouds from "./components/Web/BackgroundClouds.vue"
import NvarWeb from "./components/Web/NvarWeb.vue"
import FooterWeb from "./components/Web/FooterWeb.vue"
import NvarDash from "./components/Dashboard/NvarDash.vue"

export default {
  name: "App",
  components: { NvarWeb, FooterWeb, BackgroundClouds, NvarDash },
  data() {
    return {
      nvar: false,           // Navbar general
      nvarDash: false,       // Navbar dashboard
      BackgroundClouds: true,
      isActive: false,
      isActive2: false,
      isActive3: false
    }
  },
  methods: {
    checkRoute() {
      const guestRoutes = ["/login", "/register", "/forgot-password", "/Dashboard", "/Reservations", "/Porfile", "/paquetesDash","/MesaDeRegaloAlta","/MisMesas"];
      const dashboardRoutes = ["/Dashboard","/Reservations","/Porfile","/paquetesDash","/MesaDeRegaloAlta","/MisMesas"];

      this.nvar = !guestRoutes.includes(this.$route.path);
      this.nvarDash = dashboardRoutes.includes(this.$route.path);
    },
    actualizarVariables(nuevosValores) {
      this.BackgroundClouds = !!nuevosValores.isActive;
      this.isActive = nuevosValores.isActive;
      this.isActive2 = nuevosValores.isActive2;
      this.isActive3 = nuevosValores.isActive3;
    },
    actualizarVariablesDash(nuevosValores) {
      this.BackgroundClouds = nuevosValores.isActive;
      this.isActive2 = nuevosValores.isActive2;
      this.isActive3 = nuevosValores.isActive3;
      document.body.style.backgroundColor = "#f8f9fa";
    }

  },
  created() {
    // Revisar la ruta al cargar
    this.checkRoute();

    // Revisar ruta al cambiar
    watch(() => this.$route.path, () => {
      this.checkRoute();
    });
  }
}
</script>
